export default __webpack_public_path__ + "static/media/timer.429f8428.jpeg";